<div>
  @if (displaySnapIn) {
    <img alt="QR Code Icon"
      class="offer-type__icon"
      src="../../../../assets/img/snap_in_icon.svg"
      />
  }
  <span class ="offer-type__left-space" >{{offerType}}</span>
</div>
